// extracted by mini-css-extract-plugin
module.exports = {"flight_count":"flight_count-2CVSR","flight_direction":"flight_direction-1RcLV","card":"card-3UCvw","baggage__icon":"baggage__icon-3NDYc"};